export default __webpack_public_path__ + "static/media/scikitlearn.544ebfc7.svg";